//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.MyBusiness',
                {
                    url: '/Business',
                    component: 'myBusinessComponent',
                    redirectTo: 'Portal.MyBusiness.PolicyList',
                    resolve: {},
                });
        }
    ]);

    app.component('myBusinessComponent', {
        templateUrl: 'App.Portal/States/MyBusiness/MyBusiness.template.html',
        controller: 'MyBusinessController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
        }
    });

    app.controller('MyBusinessController', MyBusinessController);

    MyBusinessController.$inject = [];

    function MyBusinessController() {
        var $ctrl = this;

        $ctrl.title = 'Business';
    }
})(window.angular, window.app);